/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --nve-sys-interaction-background: var(--nve-sys-interaction-background-200);
  --nve-sys-interaction-field-background: var(--nve-sys-interaction-background-200);
  --background: var(--nve-sys-layer-container-background);
  --color: var(--nve-sys-layer-canvas-color);
  --border-radius: var(--nve-ref-border-radius-lg);
  --box-shadow: var(--nve-ref-shadow-100);
  --border-bottom: none;
  --border: 0;
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  border-bottom: var(--border-bottom);
  background: var(--background);
  border: var(--border);
  color: var(--color);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  overflow: hidden;
  contain: none;
  width: stretch;
}

[internal-host] {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  height: 100%;
}

:host([container='full']) {
  --border-bottom: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);
  --border-radius: 0;
}

:host([container='flat']) {
  --nve-sys-interaction-background: unset;
  --nve-sys-interaction-field-background: unset;
  --background: transparent;
  --border-bottom: none;
  --border-radius: 0;
  --box-shadow: none;
}

slot:not([name]) {
  scrollbar-color: var(--nve-sys-scrollbar-thumb-color) var(--nve-sys-scrollbar-track-color);
  scrollbar-width: var(--nve-sys-scrollbar-width);
  display: block;
  width: 100%;
  height: 100%;
  overflow: auto;
}
